import { createContext } from "react";

export const AppsContext = createContext({});
